export default __webpack_public_path__ + "static/media/WNo.1-2.bf6730ef.jpg";